import { Box, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import colors from '../../styles/colors';

const Header = (props) => {
  const {
    title,
    subTitle,
    showSubTitle = true,
    showBackButton = false,
    onBackClick
  } = props;

  return (
    <>
      <Box sx={{ backgroundColor: colors.secondary, paddingTop: '20px' }}>
        <Stack sx={{ padding: '0px 10px' }} alignItems={'center'} justifyContent={'space-evenly'} direction={'row'}>
          <IconButton variant="outlined"
            sx={{
              visibility: showBackButton ? 'visible' : 'hidden',
              color: colors.white,
              border: '2px solid',
              borderRadius: 2,
              padding: '0px 10px',
              height: 40
            }}
            onClick={onBackClick}
          ><ArrowBackIcon

              sx={{ color: colors.white }} /></IconButton>
          <Typography variant="h4" component="div" sx={{ alignSelf: 'center', color: colors.white, pb: '0px' }}>
            {title}
          </Typography>
          <Box />
        </Stack>
        <div style={{ minHeight: 50, paddingLeft: '20px' }}>
          {showSubTitle &&
            <Typography
              variant="body1"
              component="div"
              sx={{
                textAlign: 'center',
                flexGrow: 1,
                color: colors.white,
                paddingTop: '10px'
              }}>
              {subTitle}
            </Typography>
          }
        </div>
      </Box>
    </>
  );
}

export default Header;